// extracted by mini-css-extract-plugin
module.exports = {"button":"_2R3OZ","link":"_2yrwF","container":"OWOxN","mobile-container":"Glleb","mobileContainer":"Glleb"};